import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const initUspCarousel = () => {
  const wrapperElement = document.querySelector(".usp-carousel-wrapper");
  if (!wrapperElement) return;

  gsap.registerPlugin(ScrollTrigger);
  const tl = gsap.timeline({
    paused: true,
    repeat: 0,
  });

  tl.fromTo(
    ".usp-carousel-slide",
    {
      scale: 0.7,
      opacity: 0,
      y: "30%",
      transformOrigin: "left bottom",
    },
    {
      opacity: 1,
      scale: 1,
      y: "0",
      stagger: 4,
    },
    0,
  );

  tl.to(
    "div.usp-carousel-slide:not(:last-of-type)",
    {
      y: "-30%",
      opacity: 0,
      stagger: 4,
    },
    3.6,
  );

  let sectionInView = false;
  let initialized = false;

  ScrollTrigger.observe({
    type: "wheel, touch, scroll",
    onDown: () => {
      if (sectionInView && !initialized) {
        tl.play();
        initialized = true;
      }
    },
  });

  ScrollTrigger.create({
    trigger: wrapperElement,
    start: "top center",
    end: "bottom center",
    markers: false,
    onEnter: () => {
      sectionInView = true;
      if (!initialized) {
        tl.play();
        initialized = true;
      }
      tl.play();
    },
    onLeave: () => {
      sectionInView = false;
    },
  });
};

export default initUspCarousel;
